import useIsMobile from '../hooks/useIsMobile';
import React, { useState, useEffect } from 'react';
import { vehiclesAPI } from '../services/api';
import VehicleIllustration from '../components/VehicleIllustration';
import toast from 'react-hot-toast';

// [NEW] Ícones de linha pro badge "Foto ✓" / "Vídeo ✓" da tela do relatório — mesmo
// conjunto usado no badge equivalente do histórico de serviços (VehicleDashboard.jsx) e
// nos chips de Tipo de Serviço (ServiceModal.jsx). Mantém o padrão de layout consistente
// em vez de emoji, que rendem diferente dependendo do sistema. Só usado na versão de
// TELA — a versão de impressão/PDF continua com o link por extenso em texto puro.
const MEDIA_BADGE_ICONS = {
  camera: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  video: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
  check: <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
};

const R = {
  eyebrow: { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.8px', color: '#e97117', marginBottom: '6px' },
  h1: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', lineHeight: 0.95, letterSpacing: '-0.02em', margin: 0, color: '#14562e' },
  subtitle: { color: '#6a7268', margin: '6px 0 0', fontSize: '15px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '20px', marginTop: '28px' },
  card: { background: '#fff', border: '1px solid #e5ddc9', borderRadius: '22px', padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px', transition: 'transform 0.15s, box-shadow 0.15s' },
  cardHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  emojiBox: { width: '60px', height: '60px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  readyBadge: { background: '#e6f0e9', color: '#14562e', fontSize: '11px', fontWeight: 700, padding: '4px 10px', borderRadius: '999px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  name: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '18px', color: '#14562e', margin: 0 },
  plate: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, background: '#111', color: '#fff', padding: '3px 10px', borderRadius: '6px', fontSize: '12px', letterSpacing: '1.5px', display: 'inline-block', marginTop: '4px' },
  meta: { fontSize: '13.5px', color: '#6a7268' },
  metaVal: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, color: '#14562e' },
  btn: { width: '100%', padding: '14px', borderRadius: '12px', background: '#14562e', color: '#fff', fontWeight: 700, fontSize: '14px', cursor: 'pointer', border: 'none', fontFamily: "'DM Sans', sans-serif", transition: 'background 0.15s' },
  // Modal
  overlay: { position: 'fixed', inset: 0, background: 'rgba(15,64,35,.4)', backdropFilter: 'blur(6px)', zIndex: 200, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 20px', overflowY: 'auto' },
  modal: { background: '#fff', borderRadius: '22px', maxWidth: '720px', width: '100%', boxShadow: '0 20px 48px rgba(15,64,35,.14)', overflow: 'hidden' },
  modalTop: { display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '16px 24px', borderBottom: '1px solid #efe8d6', alignItems: 'center' },
  modalBtn: { display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '10px 18px', borderRadius: '10px', fontWeight: 700, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", transition: 'all 0.15s' },
  report: { padding: '40px' },
  reportHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '16px', borderBottom: '2px solid #14562e', marginBottom: '24px' },
  reportTitle: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', fontSize: '22px', color: '#183d24', margin: '16px 0 4px' },
  reportSub: { color: '#6a7268', fontSize: '13px' },
  sectionTitle: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, textTransform: 'uppercase', fontSize: '14px', color: '#e97117', letterSpacing: '1.5px', margin: '24px 0 12px' },
  dataGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '20px' },
  dataLabel: { fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: '#6a7268', marginBottom: '2px' },
  dataValue: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: '15px', color: '#183d24' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '13.5px' },
  th: { textAlign: 'left', padding: '10px 12px', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: '#6a7268', borderBottom: '2px solid #efe8d6' },
  td: { padding: '12px', borderBottom: '1px solid #efe8d6', color: '#183d24' },
  tdRight: { padding: '12px', borderBottom: '1px solid #efe8d6', textAlign: 'right', fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, color: '#14562e' },
  nicoBadge: { background: '#14562e', color: '#fff', fontSize: '12px', fontWeight: 700, padding: '8px 16px', borderRadius: '999px', display: 'inline-flex', alignItems: 'center', gap: '6px' },
  // [NEW] mídia (foto/vídeo) na tabela do relatório — dois estilos, um por contexto
  // (ver comentário no <style> do ReportModal): badge-pílula na tela, link por extenso
  // quando impresso/exportado em PDF (só um dos dois fica visível por vez).
  // mediaBadge é o PADRÃO de layout pra "indicador de mídia anexada" em qualquer lugar
  // do app — mesma receita (fundo #e6f0e9, texto #14562e, check ✓) usada nos badges
  // 📷/🎥 do histórico de serviços em VehicleDashboard.jsx. Se um novo lugar precisar
  // mostrar esse mesmo tipo de indicador, replicar esse estilo em vez de inventar um novo.
  mediaBadge: { display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#e6f0e9', color: '#14562e', fontSize: '11px', fontWeight: 700, padding: '3px 9px', borderRadius: '999px', textDecoration: 'none', whiteSpace: 'nowrap' },
  mediaPrintLink: { color: '#14562e', fontWeight: 600, textDecoration: 'none', fontSize: '12px', display: 'block', lineHeight: 1.6 },
};

function genDocNumber(vehicleId) {
  const d = new Date();
  return `NC-${d.getFullYear()}-${String(Math.abs(vehicleId?.hashCode?.() || Math.floor(Math.random() * 9999))).padStart(4, '0')}-CV`;
}

/* ── Report Modal ─────────────────────── */
function ReportModal({ vehicle, services, onClose }) {
  const m = useIsMobile();
  if (!vehicle) return null;

  const validatedServices = services.filter(s => s.validation_status === 'validated');
  const allServices = services;
  const totalCost = allServices.reduce((sum, s) => sum + (Number(s.cost) || 0), 0);
  const docNum = `NC-${new Date().getFullYear()}-${String(vehicle.id).slice(-4).toUpperCase()}-CV`;
  const today = new Date().toLocaleDateString('pt-BR');

  const handlePrint = () => window.print();

  return (
    <div style={R.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      {/* [NEW] Mídia (foto/vídeo) aparece de dois jeitos diferentes dependendo de pra
          onde o relatório vai: na tela, um ícone compacto e agradável (abre a mídia
          numa nova aba, já temos a URL real aqui mesmo, autenticado); impresso ou
          exportado como PDF (window.print()), o ícone não serve pra nada em papel —
          então essa mesma célula troca pro link curto por extenso
          (usenico.com.br/m/<código>), que dá pra digitar à mão E continua clicável
          se for um PDF digital. */}
      <style>{`
        .nico-media-print { display: none; }
        @media print {
          .nico-media-screen { display: none !important; }
          .nico-media-print { display: block !important; }
        }
      `}</style>
      <div style={R.modal}>
        {/* Top bar */}
        <div style={R.modalTop}>
          <span style={{ cursor: 'pointer', fontWeight: 600, fontSize: '14px', color: '#6a7268', marginRight: 'auto' }} onClick={onClose}>Fechar</span>
          <button style={{ ...R.modalBtn, background: '#fff', color: '#14562e', border: '1.5px solid #e5ddc9' }}
            onMouseOver={e => { e.currentTarget.style.borderColor = '#14562e'; }}
            onMouseOut={e => { e.currentTarget.style.borderColor = '#e5ddc9'; }}>
            🔗 Compartilhar link
          </button>
          <button style={{ ...R.modalBtn, background: '#14562e', color: '#fff', border: 'none' }} onClick={handlePrint}
            onMouseOver={e => { e.currentTarget.style.background = '#1a6b3a'; }}
            onMouseOut={e => { e.currentTarget.style.background = '#14562e'; }}>
            ⬇ Baixar PDF
          </button>
        </div>

        {/* Report content */}
        <div style={{ ...R.report, padding: m ? '20px' : '40px' }} id="report-content">
          {/* Header */}
          <div style={R.reportHead}>
            <img src="/nico-1.png" alt="NICO" style={{ height: '32px' }} />
            <span style={R.nicoBadge}>✓ VERIFICADO NICO</span>
          </div>

          <h2 style={R.reportTitle}>Relatório de histórico veicular</h2>
          <p style={R.reportSub}>Emitido em {today} · Documento nº {docNum}</p>

          {/* Vehicle data */}
          <div style={R.sectionTitle}>Dados do veículo</div>
          <div style={{ ...R.dataGrid, gridTemplateColumns: m ? '1fr 1fr' : '1fr 1fr 1fr' }}>
            <div><div style={R.dataLabel}>Modelo</div><div style={R.dataValue}>{vehicle.brand} {vehicle.model}</div></div>
            <div><div style={R.dataLabel}>Ano/Modelo</div><div style={R.dataValue}>{vehicle.year} / {vehicle.year}</div></div>
            <div><div style={R.dataLabel}>Placa</div><div style={R.dataValue}>{vehicle.plate || '—'}</div></div>
            <div><div style={R.dataLabel}>Cor</div><div style={R.dataValue}>{vehicle.color || '—'}</div></div>
            <div><div style={R.dataLabel}>Combustível</div><div style={R.dataValue}>{vehicle.fuel_type || 'Flex'}</div></div>
            <div><div style={R.dataLabel}>KM atual</div><div style={R.dataValue}>{vehicle.current_km?.toLocaleString('pt-BR')} km</div></div>
          </div>

          {/* Services table */}
          <div style={R.sectionTitle}>
            Histórico de serviços validados · {validatedServices.length} registros
          </div>
          {allServices.length === 0 ? (
            <p style={{ color: '#6a7268', fontSize: '14px' }}>Nenhum serviço registrado.</p>
          ) : (
            <table style={R.table}>
              <thead>
                <tr>
                  <th style={R.th}>Data</th>
                  <th style={R.th}>Serviço</th>
                  <th style={R.th}>KM</th>
                  <th style={R.th}>Profissional</th>
                  {/* [NEW] coluna de mídia — só existe conteúdo quando o serviço tem foto/vídeo anexado */}
                  <th style={R.th}>Mídia</th>
                  <th style={{ ...R.th, textAlign: 'right' }}>Valor</th>
                </tr>
              </thead>
              <tbody>
                {allServices.map(s => (
                  <tr key={s.id}>
                    <td style={R.td}>{s.performed_at ? new Date(s.performed_at).toLocaleDateString('pt-BR') : '—'}</td>
                    <td style={R.td}>
                      {s.service_type_name || s.custom_service_name || 'Serviço'}
                      {s.notes ? ` (${s.notes.substring(0, 30)})` : ''}
                    </td>
                    <td style={R.td}>{(s.km_at_service || 0).toLocaleString('pt-BR')}</td>
                    <td style={R.td}>
                      {s.professional_name || s.professional_name_app || '—'}
                      {s.validation_status === 'validated' ? ' ✓' : ''}
                    </td>
                    {/* [NEW] Mídia de comprovação — ver o <style> logo acima do modal.
                        Tela: ícones compactos, abrem a mídia numa nova aba (já temos a
                        URL aqui, autenticado). Impressão/PDF: o link curto
                        (usenico.com.br/m/<código>, gerado em backend/utils/mediaLinks.js)
                        aparece por extenso — digitável no papel, clicável num PDF digital.
                        Se o serviço ainda não tem o código (photo_code/video_code — depende
                        do GET que carrega o relatório repassar esse campo), a versão de
                        impressão simplesmente não mostra nada pra aquele item. */}
                    <td style={R.td}>
                      {!s.photo_url && !s.video_url && <span style={{ color: '#c7c0ad' }}>—</span>}

                      <span className="nico-media-screen" style={{ display: 'inline-flex', gap: '6px' }}>
                        {s.photo_url && (
                          <a href={s.photo_url} target="_blank" rel="noreferrer" title="Ver foto" style={R.mediaBadge}>{MEDIA_BADGE_ICONS.camera} Foto {MEDIA_BADGE_ICONS.check}</a>
                        )}
                        {s.video_url && (
                          <a href={s.video_url} target="_blank" rel="noreferrer" title="Ver vídeo" style={R.mediaBadge}>{MEDIA_BADGE_ICONS.video} Vídeo {MEDIA_BADGE_ICONS.check}</a>
                        )}
                      </span>

                      <span className="nico-media-print">
                        {s.photo_url && s.photo_code && (
                          <a href={`https://usenico.com.br/m/${s.photo_code}`} style={R.mediaPrintLink}>
                            📷 usenico.com.br/m/{s.photo_code}
                          </a>
                        )}
                        {s.video_url && s.video_code && (
                          <a href={`https://usenico.com.br/m/${s.video_code}`} style={R.mediaPrintLink}>
                            🎥 usenico.com.br/m/{s.video_code}
                          </a>
                        )}
                      </span>
                    </td>
                    <td style={R.tdRight}>{s.cost ? `R$ ${Number(s.cost).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* ── Summary Banner ─────────── */}
          <div style={{ background: '#14562e', color: '#fff', borderRadius: '14px', padding: '24px 28px', marginTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <div>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', opacity: 0.7, marginBottom: '4px' }}>Total investido em manutenção</div>
              <div style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '28px' }}>
                R$ {totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', opacity: 0.7, marginBottom: '4px' }}>Serviços verificados</div>
              <div style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '28px' }}>
                {validatedServices.length} de {allServices.length}
              </div>
            </div>
          </div>

          {/* ── Análise NICO ──────────── */}
          <div style={{ marginTop: '24px' }}>
            <div style={{ ...R.sectionTitle, marginTop: 0 }}>Análise NICO</div>
            <p style={{ fontSize: '15px', lineHeight: 1.7, color: '#333', margin: 0 }}>
              {(() => {
                const pct = allServices.length > 0 ? (validatedServices.length / allServices.length * 100) : 0;
                const rating = pct >= 80 ? 'EXCELENTE' : pct >= 50 ? 'BOM' : pct > 0 ? 'REGULAR' : 'SEM DADOS';
                const ratingColor = pct >= 80 ? '#14562e' : pct >= 50 ? '#e97117' : '#c94a2f';
                if (allServices.length === 0) return 'Este veículo ainda não possui serviços registrados na plataforma NICO.';
                return <>
                  Este veículo apresenta histórico de manutenção <b style={{ color: ratingColor }}>{rating}</b>.
                  {pct >= 80 && ' Todas as manutenções estão em dia, com serviços validados por profissionais credenciados na rede NICO. Nenhum serviço crítico pendente.'}
                  {pct >= 50 && pct < 80 && ` ${validatedServices.length} de ${allServices.length} serviços foram validados por profissionais. Recomenda-se validar os serviços restantes para aumentar a confiabilidade do histórico.`}
                  {pct > 0 && pct < 50 && ` Apenas ${validatedServices.length} de ${allServices.length} serviços possuem validação profissional. Recomenda-se buscar validação para fortalecer o histórico na hora da venda.`}
                </>;
              })()}
            </p>
          </div>

          {/* ── Footer ────────────────── */}
          <div style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #efe8d6', fontSize: '12px', color: '#6a7268', textAlign: 'center', lineHeight: 1.8 }}>
            Documento gerado automaticamente pelo NICO · usenico.com.br<br/>
            Cada serviço deste relatório foi validado por profissional cadastrado na plataforma NICO.
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Main Page ────────────────────────────── */
export default function ReportsPage() {
  const m = useIsMobile();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    vehiclesAPI.list()
      .then(r => setVehicles(r.vehicles || []))
      .catch(() => toast.error('Erro ao carregar veículos'))
      .finally(() => setLoading(false));
  }, []);

  const openReport = async (vehicle) => {
    try {
      const r = await vehiclesAPI.get(vehicle.id);
      setReportData({ vehicle: r.vehicle, services: r.services || [] });
    } catch { toast.error('Erro ao gerar relatório'); }
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', flexDirection: 'column', gap: '12px' }}>
      <div className="spinner" style={{ width: '32px', height: '32px' }} />
      <span style={{ fontSize: '13px', color: '#6a7268' }}>Carregando...</span>
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: '4px' }}>
        <span style={R.eyebrow}>Documentos</span>
        <h1 style={{ ...R.h1, fontSize: m ? '26px' : '38px' }}>Relatórios de venda</h1>
        <p style={R.subtitle}>Gere um documento profissional pra valorizar seu carro na hora da venda.</p>
      </div>

      {vehicles.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <div style={{ fontSize: '48px', opacity: 0.3, marginBottom: '16px' }}>📄</div>
          <p style={{ color: '#6a7268', fontSize: '14px' }}>Adicione veículos na garagem para gerar relatórios.</p>
        </div>
      ) : (
        <div style={R.grid}>
          {vehicles.map(v => {
            const isMotorcycle = v.type === 'motorcycle';
            return (
              <div key={v.id} style={R.card}
                onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(15,64,35,.09)'; }}
                onMouseOut={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}>
                <div style={R.cardHead}>
                  <div style={{ ...R.emojiBox, background: isMotorcycle ? '#fdece0' : '#e6f0e9' }}>
                    <VehicleIllustration type={v.type} color={isMotorcycle ? '#e97117' : '#14562e'} size={38} />
                  </div>
                  <span style={R.readyBadge}>Pronto</span>
                </div>
                <div>
                  <h3 style={R.name}>{v.nickname || `${v.brand} ${v.model}`} {v.year}</h3>
                  {v.plate && <span style={R.plate}>{v.plate}</span>}
                </div>
                <p style={R.meta}>
                  {v.services_count || 0} serviços registrados
                  {v.fipe_value && <> · valor estimado <b style={R.metaVal}>R$ {v.fipe_value.toLocaleString('pt-BR')}</b></>}
                </p>
                <button style={R.btn} onClick={() => openReport(v)}
                  onMouseOver={e => { e.currentTarget.style.background = '#1a6b3a'; }}
                  onMouseOut={e => { e.currentTarget.style.background = '#14562e'; }}>
                  Gerar relatório PDF
                </button>
              </div>
            );
          })}
        </div>
      )}

      {reportData && (
        <ReportModal
          vehicle={reportData.vehicle}
          services={reportData.services}
          onClose={() => setReportData(null)}
        />
      )}
    </div>
  );
}
